// Global Supply Chain page English translations

export default {
  pageTitle: "Global Supply Chain",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "Global Supply Chain",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Efficient Global Supply Chain",
  description1: "PT Eagle Industry Indonesia maintains an efficient and reliable global supply chain network to ensure timely delivery of our products to customers worldwide. Our strategic distribution system combines local manufacturing capabilities with global logistics expertise to provide responsive service while maintaining cost efficiency.",
  description2: "Our supply chain is designed to minimize lead times, reduce inventory costs, and ensure product availability when and where our customers need it. We have developed robust partnerships with logistics providers and established regional distribution centers to create a resilient and flexible supply network that can adapt to changing market demands.",
  
  // Capabilities section
  capabilitiesTitle: "Our Supply Chain Capabilities:",
  capabilities: [
    "Strategic distribution centers across key global markets",
    "Advanced inventory management systems for optimal stock levels",
    "Multiple shipping options including express delivery services",
    "Real-time order tracking and visibility throughout delivery process",
    "Customs clearance expertise for international shipments",
    "Flexible packaging solutions to protect products during transit",
    "Emergency delivery capabilities for critical requirements"
  ],
  
  // Regional distribution section
  distributionTitle: "Regional Distribution Network:",
  distributionDescription: "Our global presence is strengthened by regional distribution centers strategically located to serve major industrial markets. These facilities maintain comprehensive inventory of standard products and can quickly assemble custom orders, significantly reducing delivery times while ensuring product quality is maintained throughout the supply chain.",
  
  // Metrics
  deliveryPerformance: "Delivery Performance",
  deliveryPerformanceDesc: "On-time delivery rate exceeding 98% globally",
  globalReach: "Global Reach",
  globalReachDesc: "Distribution network spanning over 50 countries",
  inventoryManagement: "Inventory Management",
  inventoryManagementDesc: "Advanced systems ensuring optimal stock availability",
  logisticsPartners: "Logistics Partners",
  logisticsPartnersDesc: "Strategic partnerships with leading global carriers",
  
  // Technology section
  technologyTitle: "Supply Chain Technology:",
  technologyDescription: "We leverage advanced supply chain management technologies to optimize our operations and provide visibility to our customers. Our systems include automated inventory management, demand forecasting, route optimization, and real-time tracking capabilities. These technologies enable us to respond quickly to changing requirements and provide accurate delivery information.",
  
  // Sustainable logistics section
  sustainableTitle: "Sustainable Logistics:",
  sustainableDescription: "Our global supply chain incorporates sustainability initiatives to minimize environmental impact while maintaining service efficiency. We optimize shipping routes to reduce carbon emissions, utilize eco-friendly packaging materials, and work with logistics partners who share our commitment to environmental responsibility.",
  
  // Customer integration section
  customerIntegrationTitle: "Customer Supply Chain Integration:",
  customerIntegrationDescription: "We offer integrated supply chain solutions that align with our customers' procurement and inventory systems. Through electronic data interchange, vendor-managed inventory programs, and customized delivery schedules, we help our customers optimize their own supply chain operations while ensuring reliable product availability.",
  
  // CTA button
  inquireDelivery: "Inquire About Delivery Options",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  afterSalesServiceDesc: "Comprehensive after-sales support to ensure customer satisfaction.",
  customManufacturingDesc: "Tailored manufacturing solutions to meet specific customer requirements.",
  technicalSupportDesc: "Expert technical assistance to ensure optimal product performance.",
  readMore: "Read more"
};